<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <a-card class="m-height-full m-display-flex flex-column nowrap w-head">
      <template slot="title">
        <h4 class="margin-remove">
          <a-icon
            type="star"
            theme="filled"
            class="margin-right-small"
          />Administrator
        </h4>
      </template>
      <template slot="extra">
        <Submenu pages="Administrator"/>
      </template>
      <router-view class="height-full" />
    </a-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Submenu from "@/components/menu/Submenu.vue";
export default {
  name: "wrapper",
  components: {
    Submenu,
  },
  computed: {
    ...mapGetters(["getScreen", "getNavigation"]),
  },
};
</script>

<style lang="less"></style>
